/*
*
* UTILITA E STRUMENTI
*
*/


/*
* FULLPAGE
*/


function fullpageConfig(){

  var configurations= {
          autoScrolling: true,
          /* scrollHorizontally: false,*/
          licenseKey: "5DF7BFBF-2E44401C-B19EA863-9FA1D308",
          
         //synologyme.eddymouse
        /*  responsiveSlidesKey: "ZWRkeW1vdXNlLnN5bm9sb2d5Lm1lXzRmV2NtVnpjRzl1YzJsMlpWTnNhV1JsY3c9PU9XVQ==",
          parallaxKey: "ZWRkeW1vdXNlLnN5bm9sb2d5Lm1lX1dLQ2NHRnlZV3hzWVhnPXo2NQ==", 
          fadingEffectKey:  "ZWRkeW1vdXNlLnN5bm9sb2d5Lm1lX0kyNlptRmthVzVuUldabVpXTjBwWVE=",*/

          //dorothymagatz.it
          responsiveSlidesKey: "ZG9yb3RoeW1hZ2F0ei5pdF9sTVFjbVZ6Y0c5dWMybDJaVk5zYVdSbGN3PT1kajE=",
          parallaxKey: "ZG9yb3RoeW1hZ2F0ei5pdF82RWZjR0Z5WVd4c1lYZz1weEE=", 
          fadingEffectKey:  "ZG9yb3RoeW1hZ2F0ei5pdF90OFNabUZrYVc1blJXWm1aV04wSUt6",

          parallax: false,
          fadingEffect: 'slides',
          parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},
          responsiveSlides: true,
          fitToSection: true,
          responsiveWidth: 900,
          navigation: true ,
          navigationPosition: 'right',
          slidesNavigation: true,
          slidesNavPosition: 'bottom', 
          css3: true,
          scrollOverflow: true,
          fixedElements: '',
          paddingTop:'0px',
          recordHistory: false,
          bigSectionsDestination : 'top',
          afterRender: function(){               
           
          },
          /*afterLoad: function(){                
           
          },*/
          afterResponsive: function(isResponsive){ 
            
           fullpage_api.setFitToSection(true);         

            if(isResponsive){                           
                if( jQuery('body').hasClass('stickymenu')){
                }else{
                  jQuery('body').addClass('stickymenu');
                }
              //fullpage_api.setAutoScrolling(true);
            }else{
               //console.log("isresponsive false: "+isResponsive);               
                if( jQuery('body').hasClass('stickymenu')){
                  jQuery('body').removeClass('stickymenu');
                }else{

                }
            }
          }, 
        };

  return configurations;
}